
export enum Endpoints {
	exitSurvey = '3c8f0bd6-16c7-467a-84ef-083d34e17bae',
	flFeedback = 'a4814b53-9472-4b25-a15a-236ce46f1b6c',
	loadWidgets = '11d24879-b6be-4d07-8bd0-4f31b3779f4e',
	preGenReport = '2da8242a-708b-46c0-ab79-31e9191bf02a',
	userGPS = 'baf38e9c-b8c8-4406-8f9f-ce4cdbf90354',
	voiceFeedback = '4c327a09-874b-4346-ae4d-f9359a3945e6',
	voiceReport = '67f18a22-d080-4480-adca-960164fafb66',
}

export const postValues = async (ep: Endpoints, values: unknown) => {
	const prefix = 'https://n8n.bodyspec.com/webhook';
	try {
		return await fetch(`${prefix}/${ep}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(values),
		});
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error('Error posting values to n8n:', e);
		return null;
	}
};
